import React, { useEffect, useRef, useState } from 'react';
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    Row,
    Spinner,
    Stack,
} from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import OrderPair from './orderPair';
import './orders.scss';
import LoadingComponent from '../LoadingComponent';
import {
    useAddOpticBoxMutation,
    useOrdersAddMutation,
    useOrderseditMutation,
} from './ordersApi';
import apiConfig from '../../Api/config';
import Swal from 'sweetalert2';
const AddOrders = () => {
    const { state } = useLocation();
    console.log(state?.view);

    // Create base config for a single order
    const createBaseOrderConfig = () => ({
        orderNumber: '',
        patientEmail: state?.eyeData?.patientEmail,
        doctorEmail: '',
        opticianName: state?.eyeData?.opticianName,
        opticianEmail: state?.eyeData?.opticianEmail,
        posEmail: state?.eyeData?.posEmail,
        posName: state?.eyeData?.posName,
        testName: state?.eyeData?.testName,
        status: 'Pending',
        recoOpticianRightSPH: state?.eyeData?.testDetails[6].sph,
        recoOpticianRightCYL: state?.eyeData?.testDetails[6].cyl,
        recoOpticianRightAXIS: state?.eyeData?.testDetails[6].axe,
        recoOpticianRightADD: state?.eyeData?.testDetails[6].add,
        recoOpticianRightPD: state?.eyeData?.testDetails[6].pd,
        recoOpticianRightPDHIGH: state?.eyeData?.testDetails[6].phigh,
        recoOpticianLeftSPH: state?.eyeData?.testDetails[7].sph,
        recoOpticianLeftCYL: state?.eyeData?.testDetails[7].cyl,
        recoOpticianLeftAXIS: state?.eyeData?.testDetails[7].axe,
        recoOpticianLeftADD: state?.eyeData?.testDetails[7].add,
        recoOpticianLeftPD: state?.eyeData?.testDetails[7].pd,
        recoOpticianLeftPDHIGH: state?.eyeData?.testDetails[7].phigh,
        orderRightSPH: state?.eyeData?.testDetails[6].sph,
        orderRightCYL: state?.eyeData?.testDetails[6].cyl,
        orderRightAXIS: state?.eyeData?.testDetails[6].axe,
        orderRightADD: state?.eyeData?.testDetails[6].add,
        orderRightPD: state?.eyeData?.testDetails[6].pd,
        orderRightPDHIGH: state?.eyeData?.testDetails[6].phigh,
        orderLeftSPH: state?.eyeData?.testDetails[7].sph,
        orderLeftCYL: state?.eyeData?.testDetails[7].cyl,
        orderLeftAXIS: state?.eyeData?.testDetails[7].axe,
        orderLeftADD: state?.eyeData?.testDetails[7].add,
        orderLeftPD: state?.eyeData?.testDetails[7].pd,
        orderLeftPDHIGH: state?.eyeData?.testDetails[7].phigh,
        orderType: '',
        orderTint: '',
        orderIndex: '',
        lensShape: '',
        comments: '',
        otherComments: '',
        leftHeightEye: '',
        rightHeightEye: '',
        price: '0.00 €',
        frameReference: '',
        eyetestId: state?.eyeData?.testid,
        testUniqueCode: state?.eyeData?.testUniqueCode,
        OrderPairNo: '1',
        frameColor: '',
        tiersPayant: '',
        typeofpayment: '',
        lensTypeDetails: '',
        lensType: '',
        treatment: '',
        tinttype: '',
        typeDeVision: '',
        infoSupplier: '',
        infoFrameType: '',
        InfoSubmitTrack: 'Web',
    });

    const { t } = useTranslation();
    const navigate = useNavigate();

    // Initialize with empty array, will be populated in useEffect
    const [addOrderConfig, setAddOrderConfig] = useState([]);
    const [infoOpticBoxId, setInfoOpticBoxId] = useState('');
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [opticBoxLoading, setOpticBoxLoading] = useState(false);
    const [error, setError] = useState([]);
    const [opticBoxAdded, setOpticBoxAdded] = useState(false); // NEW: Track if optic box was added
    const [addOrder] = useOrdersAddMutation();
    const [addOpticBox] = useAddOpticBoxMutation();
    const [editOrder] = useOrderseditMutation();

    useEffect(() => {
        if (loading) {
            if (state?.orderData) {
                // Edit/View mode: Use the existing order data
                const updatedOrders = state.orderData.map((order, index) => ({
                    ...order,
                    infoFrameType: order?.frameType,
                    infoSupplier: order?.supplier,
                    OrderPairNo: `${index + 1}`,
                    price: order.price || '0.00 €'
                }));

                console.log(updatedOrders, 'updatedOrders');

                if (updatedOrders.length > 0) {
                    setInfoOpticBoxId(updatedOrders[0].infoOpticBoxId);
                    // NEW: Set opticBoxAdded if there's already an optic box ID
                    if (updatedOrders[0].infoOpticBoxId) {
                        setOpticBoxAdded(true);
                    }
                }

                setAddOrderConfig(updatedOrders);
            } else {
                // Add mode: Create a single base order
                setAddOrderConfig([createBaseOrderConfig()]);
            }
            setLoading(false);
        }
    }, [loading, state]);

    function hasAnyTrueValue(arr) {
        return arr.some((obj) =>
            Object.values(obj).some((value) => value === true)
        );
    }

const handleSubmit = async (event) => {
    event.preventDefault();

    // 🔹 Validation
    const validationResults = addOrderConfig.map((item) => ({
        lensShape: item.lensShape === '',
        tiersPayant: item.tiersPayant === '',
        typeofpayment: item.typeofpayment === '',
        typeDeVision: item.typeDeVision === '',
        orderType: item.orderType === '',
        orderIndex: item.orderIndex === '',
        treatment: item.treatment === '',
        infoFrameType: item.infoFrameType === '',
        frameReference: item.frameReference === '',
        orderLeftPD: item.orderLeftPD === '0.00' || item.orderLeftPD === '',
        orderRightPD: item.orderRightPD === '0.00' || item.orderRightPD === '',
        infoSupplier: item.infoSupplier === '',
    }));

    setError(validationResults);
    if (hasAnyTrueValue(validationResults)) return;

    try {
        setButtonLoading(true);

        const response =
            state?.view === 'edit'
                ? await editOrder(addOrderConfig)
                : await addOrder(addOrderConfig);

        const raw =
            (typeof response?.data === 'string' && response.data) ||
            (typeof response?.error?.data === 'string' && response.error.data) ||
            '';

        const result = raw.trim().toLowerCase();

        // ✅ CASE 1: SUCCESS
        if (result === 'success') {
            await Swal.fire({
                icon: 'success',
                title: 'Succès',
                text: 'Commande ajoutée avec succès',
            });
            navigate('/order/list', {
                replace: true,
                state: { refresh: Date.now() }
            });

            setTimeout(() => window.location.reload(), 100);
            return;
        }

        // ⚠️ CASE 2: MAPPING WARNING → TREAT AS SUCCESS AFTER OK
        if (result.includes("le mappage des commandes n'est pas valide")) {
            const match = result.match(/paire\s+(\d+)/i);
            const pairNumber = match ? match[1] : '?';

            const confirm = await Swal.fire({
                icon: 'warning',
                title: 'Attention',
                text: `Le mappage des commandes n'est pas valide pour la paire ${pairNumber}`,
                showCancelButton: true,
                confirmButtonText: 'Envoyer',
                cancelButtonText: 'Annuler',
            });

            if (confirm.isConfirmed) {
                // ✅ Treat as success WITHOUT API call
                await Swal.fire({
                    icon: 'success',
                    title: 'Succès',
                    text: 'Commande ajoutée avec succès',
                });

                navigate('/order/list', {
                    replace: true,
                    state: { refresh: Date.now() }
                });

                setTimeout(() => window.location.reload(), 100);
            }

            return;
        }

        // ❌ CASE 3: REAL ERROR
        await Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: raw || 'Une erreur est survenue',
        });

    } catch (error) {
        console.error(error);

        await Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Erreur serveur',
        });
    } finally {
        setButtonLoading(false);
    }
};
    const addOpticBoxHandle = async () => {
        setOpticBoxLoading(true);
        const simplifiedArray = addOrderConfig.map((item) => ({
            OrderId: item?.orderId,
            OrderNumber: item?.orderNumber,
            OpticboxId: infoOpticBoxId,
            Status: 'ToBeOrdered',
            combineId: item?.infoOrderCombineId,
        }));

        console.log(simplifiedArray, 'simplifiedArray');
        try {
            let result = await addOpticBox(simplifiedArray);
            console.log(result);
            if (result.data?.success) {
                // NEW: Update state to reflect that optic box was added
                setOpticBoxAdded(true);
                setLoading(true);
                // navigate("/order/list")
            }
        } catch (error) {
            console.error('Error adding optic box:', error);
        } finally {
            setOpticBoxLoading(false);
        }
    };

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <Container fluid>
                {state?.view === 'view' ? (
                    <>
                        <Stack direction="horizontal" gap={3} className="mb-3">
                            <div className="ms-auto d-flex align-items-center w-100 justify-content-end">
                                <Form.Control
                                    className="w-auto"
                                    name="testName"
                                    type="text"
                                    value={infoOpticBoxId}
                                    onChange={(e) =>
                                        setInfoOpticBoxId(e.target.value)
                                    }
                                    placeholder={t('inputText')}
                                    // UPDATED: Disable if optic box was added or if there's already an ID
                                    disabled={opticBoxAdded || addOrderConfig[0]?.infoOpticBoxId !== ''}
                                />

                                {/* UPDATED: Show Order Check button if optic box was added or if there's already a path */}
                                {opticBoxAdded || addOrderConfig[0]?.infoOpticBoxPath !== '' ? (
                                    <Button
                                        className="ms-3"
                                        href={`${apiConfig.API_URL}${addOrderConfig[0].infoOpticBoxPath}`}
                                        target="_blank"
                                    >
                                        {t('Order Check')}
                                    </Button>
                                ) : (
                                    <Button
                                        className="ms-3"
                                        onClick={addOpticBoxHandle}
                                        disabled={opticBoxLoading}
                                    >
                                        {opticBoxLoading && (
                                            <Spinner
                                                animation="border"
                                                role="status"
                                                size="sm"
                                            >
                                                <span className="visually-hidden">
                                                    Loading...
                                                </span>
                                            </Spinner>
                                        )}{' '}
                                        {t('Envoyer')}
                                    </Button>
                                )}
                            </div>
                        </Stack>
                    </>
                ) : (
                    ''
                )}
                <Form
                    onSubmit={handleSubmit}
                    className={`${state?.view === 'view' ? 'custom_disabled' : ''}`}
                >
                    <Card>
                        <Card.Body className="modal_form">
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nom du test</Form.Label>
                                        <Form.Control
                                            name="patientEmail"
                                            type="text"
                                            value={addOrderConfig[0]?.testName || ''}
                                            placeholder={t('inputText')}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('optician')}</Form.Label>
                                        <Form.Control
                                            name="opticianName"
                                            type="text"
                                            value={addOrderConfig[0]?.opticianName || ''}
                                            placeholder={t('inputText')}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('pos')}</Form.Label>
                                        <Form.Control
                                            name="posName"
                                            type="text"
                                            value={addOrderConfig[0]?.posName || ''}
                                            placeholder={t('inputText')}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            {t('patientEmail')}
                                        </Form.Label>
                                        <Form.Control
                                            name="patientEmail"
                                            type="text"
                                            value={addOrderConfig[0]?.patientEmail || ''}
                                            placeholder={t('inputText')}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                {state?.view === 'view' ? (
                                    <>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('status')}
                                                </Form.Label>
                                                <Form.Control
                                                    name="status"
                                                    type="text"
                                                    value={
                                                        {
                                                            ToBeOrdered: "À commander",
                                                            Pending: "En attente",
                                                            Commandé: "Commandé",
                                                            Annulé: "Annulé",
                                                            SAV: "SAV",
                                                            Devis: "Devis",
                                                        }[addOrderConfig?.[0]?.status] || ""
                                                    }
                                                    placeholder={t('inputText')}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('commandNumber')}
                                                </Form.Label>
                                                <Form.Control
                                                    name="orderNumber"
                                                    type="text"
                                                    value={addOrderConfig[0]?.orderNumber || ''}
                                                    placeholder={t('inputText')}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </Col>
                                    </>
                                ) : (
                                    ''
                                )}
                            </Row>
                        </Card.Body>
                    </Card>
                    <OrderPair
                        addOrderConfig={addOrderConfig}
                        setAddOrderConfig={setAddOrderConfig}
                        error={error}
                        isEdit={state?.view === 'edit'} // ADD THIS LINE - Pass isEdit prop
                    />
                    {state?.view !== 'view' ? (
                        <Container fluid>
                            <Stack
                                direction="horizontal"
                                gap={3}
                                className="mb-3 mt-5"
                            >
                                <div className="ms-auto">
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={buttonLoading}
                                    >
                                        {buttonLoading && (
                                            <Spinner
                                                animation="border"
                                                role="status"
                                                size="sm"
                                            >
                                                <span className="visually-hidden">
                                                    Loading...
                                                </span>
                                            </Spinner>
                                        )}{' '}
                                        {t('Enregistrer')}
                                    </Button>
                                </div>
                            </Stack>
                        </Container>
                    ) : (
                        ''
                    )}
                </Form>
            </Container>
        </>
    );
};

export default AddOrders;